import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsPaperlessPreferenceFieldset extends FormFieldset {
  paperlessPreferenceField: FormField;
  paperlessPreferenceBanner: string;
}
